import React from "react";
import { gql } from "@apollo/client";
import { List, notification, Divider, FloatButton } from "antd";
import { client } from "../App";
import { migrationRunListContent } from "./MigrationRunList";
import InfiniteList from "./InfiniteList";
import { CreateMigrationModal } from "./CreateMigration";
import { DEFAULT_FEED_QUERY_LIMIT } from "../lib/pagination";

export const MIGRATION_FEED_QUERY = gql`
  query projectFeed($offset: Int, $limit: Int, $queryString: String) {
    projectFeed(offset: $offset, limit: $limit, queryString: $queryString) {
      projects {
        id
        company
        migrations {
          id
          status
          scheduledStartTime
          argoWorkflowId
        }
      }
      totalCount
      offset
      limit
      queryString
    }
  }
`;

export const DELETE_MIGRATION_MUTATION = gql`
  mutation deleteProject($id: ID!) {
    deleteProject(id: $id) {
      id
    }
  }
`;

export async function deleteMigration(e) {
  const projectId = e.target.dataset.projectId;
  client
    .mutate({
      mutation: DELETE_MIGRATION_MUTATION,
      variables: { id: projectId },
      refetchQueries: [{ query: MIGRATION_FEED_QUERY }],
    })
    .then(() => {
      notification["success"]({
        message: "Successfully deleted Migration",
      });
    })
    .catch((err) => {
      notification["error"]({
        message: "Failed to delete Migration",
        description: err.message,
      });
    });
}

function latestProjectMigration(project: any): any {
  let latestMigration: any;
  if (project.migrations.length === 0) {
    return {};
  }
  project.migrations.forEach((migration) => {
    if (
      latestMigration == null ||
      latestMigration.scheduledStartTime < migration.scheduledStartTime
    ) {
      latestMigration = migration;
    }
  });
  return latestMigration;
}

const MigrationList = () => {
  return (
    <div>
      <FloatButton.BackTop />
      <h1 style={{ float: "left" }}>Migrations</h1>
      <div style={{ float: "right" }}>
        <CreateMigrationModal />
      </div>
      <Divider />
      <InfiniteList
        query={MIGRATION_FEED_QUERY}
        recordKey="projects"
        perPage={DEFAULT_FEED_QUERY_LIMIT}
        showSearch={true}
        pollInterval={1000}
        listProps={{
          itemLayout: "vertical",
        }}
        renderListItem={(project: any) => (
          <List.Item key={project.id}>
            <List.Item.Meta
              title={
                <a
                  href={`/migrations/${project.id}`}
                >{`Migration # ${project.id} - ${project.company}`}</a>
              }
            />
            {migrationRunListContent(latestProjectMigration(project))}
          </List.Item>
        )}
      />
    </div>
  );
};

export default MigrationList;
